import { UPLOAD_RULES, uploadHint, uploadProps } from "utils/uploadRules";
import { DeleteOutlined, EyeOutlined, MailOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Modal,
  Popconfirm,
  Popover,
  Row,
  Spin,
  Table,
  Tabs,
  Tooltip,
  Upload,
} from "antd";
import { memo, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import { uploadCertificate } from "redux/actions/uploadCertificate.action";
import { uploadLabourHire } from "redux/actions/uploadLabourHire.action";
import { deletePublicLiability } from "redux/actions/deletePublicLiability.action";
import { getPublicLiability } from "../../../redux/actions/publicLiability.action";
import {
  getApiArrayDetails,
  getBase64URI,
  getPreSignedUrl,
  isValidArray,
  sendNotification,
} from "../../../utils/MyMUtils";
import Email from "../mail";

import moment from "moment";
import Flex from "components/shared-components/Flex";
const dateFormat = "DD-MM-YYYY";
const AnotherFormat = "YYYY/MM/DD";

const { TabPane } = Tabs;

const PublicLiability = () => {
  const url = window.location.pathname;
  const [activeUrl, setActiveUrl] = useState("1");
  const [typeId, setTypeId] = useState("");
  const [uploadInfo, setUploadInfo] = useState({});
  const [visible, setVisible] = useState(false);
  const [visibleMail, setVisibleMail] = useState(false);
  const [publicLiabilityUploadState, setPublicLiabilityUploadState] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploadLoader, setUploadLoader] = useState(false);
  const [form] = Form.useForm();
  const [publicLiabilityForm] = Form.useForm();


  const history = useHistory();
  const dispatch = useDispatch();
  const {
    data: { result: publicLiabilityData = [] },
  } = useSelector((state) => state.publicLiability);
  
  const fileLoadingState = useSelector(
    (state) => state.fileLoadingReducer.fileLoadingState
  );

  useEffect(() => {
    dispatch(getPublicLiability());
    return () => {};
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [visible]);

  const setMail = (elm) => {
    setVisibleMail(elm.id);
    if (visibleMail === elm.id) {
      setVisibleMail(false);
    }
  };

  useEffect(() => {
    setActiveUrl((state) => {
      switch (url) {
        case "/app/public_liability":
          return "1";
        case "/app/work_cover":
          return "2";
        default:
          return "1";
      }
    });
    return () => {
      setActiveUrl("");
    };
  }, [url]);

  const closePopover = () => {
    setVisibleMail(false);
  };

  const setUploadModel = (elm) => {
    setVisible(true);
    setTypeId("1");
  };

  function confirm(elm) {
    dispatch(deletePublicLiability(elm.id)).then((record) => {
      if (record.payload.success == true) {
        toast.success(record.payload.message);
        dispatch(getPublicLiability());
      } else {
        toast.error(record.payload.message);
        dispatch(getPublicLiability());
      }
    });
  }

  function cancel(e) {}

  function onChange(value, dateString) {}

  function onOk(value) {}

  const postUploadPdfFunction = (data) => {
    const abc = moment(data.expiry_date).format(AnotherFormat);
    dispatch(uploadCertificate(uploadInfo)).then((record) => {
      const uploadFinal = {
        type_id: typeId,
        state_id: "2",
        expiry_date: abc,
        pdf_link: record.payload.result.result,
      };
      dispatch(uploadLabourHire(uploadFinal)).then((record) => {
        if (record.payload.result.success === true) {
          dispatch(getPublicLiability());
          toast.success(record.payload.result.message);
          setVisible(false);
        } else {
          toast.error(record.payload.result.message);
          setVisible(false);
        }
      });
    });
  };

  const handleChange = async (info) => {
    setFileList([info.file]);

    if (info.file.status === "removed") {
      publicLiabilityForm.setFieldsValue({ publicLiabilityFile: [] });
      setFileList([]);
      return;
    }
  };

  const handlePublicLiabilityUpload = () => {
    publicLiabilityForm.validateFields().then(async ({ publicLiabilityFile: file, expiry_date }) => {
      setUploadLoader(true);
      const { base64String } = await getBase64URI(file.file.originFileObj);

      const fileUploadBody = {
        certificate_type: "public-liability",
        filename: file.file.name,
        file: base64String,
      };

      dispatch(uploadCertificate(fileUploadBody))
        .then(({ payload }) => {
          if (!payload.error) {
            const certificateUploadBody = {
              type_id: "1",
              state_id: "2",
              expiry_date: moment(expiry_date).format(AnotherFormat),
              pdf_link: payload.result.result,
            };

            dispatch(uploadLabourHire(certificateUploadBody)).then((response) => {
              if (!response.payload.error) {
                sendNotification({ notificationType: "success", payload: response.payload.result.message });
                setFileList([]);

                dispatch(getPublicLiability());
              }
            });
          } else {
            sendNotification({ notificationType: "error", message: "Something went wrong. Please try again." });
            setFileList([]);
          }
        })
        .finally(() => {
          setPublicLiabilityUploadState(false);
          setUploadLoader(false);
          publicLiabilityForm.resetFields();
        });
    });
  };

  const uploadSettings = {
    ...uploadProps(UPLOAD_RULES.PDF),
    onChange: (info) => {
      let selectedFile = info.fileList;
      let file = null;
      let fileName;
      if (selectedFile.length > 0) {
        let fileToLoad = selectedFile[selectedFile.length - 1].originFileObj;
        fileName = fileToLoad.name;
        let reader = new FileReader();
        reader.onload = function (fileEvent) {
          file = fileEvent.target.result;
          let name = fileName.split(".");
          const uploadInfo = {
            certificate_type: "public-liability",
            filename: name[0],
            file: file,
          };
          setUploadInfo(uploadInfo);
          // return uploadInfo;
        };
        reader.readAsDataURL(fileToLoad);
      }
    },
  };
  const columns = [
    {
      title: "Name",
      key: "name",
      width: "50%",
      render: () => "Public Liability Insurance",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "50%",
      render: (_, record, row) => {
        return (
          <div>
            <span className="mr-3">
              <Tooltip title="View" color="rgb(47, 111, 224)">
                <Button disabled={!record.pdf_link} onClick={() => getPreSignedUrl(record.pdf_link)}>
                  {fileLoadingState !== record.pdf_link ? (
                    <EyeOutlined
                      style={{
                        color: !record.pdf_link ? "#00000040" : "rgb(47, 111, 224)",
                      }}
                    />
                  ) : (
                    <Spin size="small" />
                  )}
                </Button>
              </Tooltip>
            </span>
            <span className="mr-3">
              <Popover title="Additional Emails" content={<Email passData={record} visibleMailprop={closePopover} />} visible={record.id === visibleMail} trigger="click">
                <Tooltip title="Mail" color="rgb(47, 111, 224)">
                  <Button disabled={!record.pdf_link} onClick={() => setMail(record)}>
                    <MailOutlined
                      style={{
                        color: !record.pdf_link ? "#00000040" : "rgb(47, 111, 224)",
                      }}
                    />
                  </Button>
                </Tooltip>
              </Popover>
            </span>
            <span className="mr-3">
              <Tooltip title="Upload" color="rgb(47, 111, 224)">
                <Button onClick={() => setUploadModel(record)}>
                  <UploadOutlined />
                </Button>
              </Tooltip>
            </span>
            <span>
              <Popconfirm title="Are you sure to delete this data?" onConfirm={() => confirm(record)} onCancel={() => cancel} okText="Yes" cancelText="No">
                <Tooltip title="Delete" color="rgb(47, 111, 224)">
                  <Button disabled={!record.pdf_link}>
                    <DeleteOutlined
                      style={{
                        color: !record.pdf_link ? "#00000040" : "rgb(47, 111, 224)",
                      }}
                    />
                  </Button>
                </Tooltip>
              </Popconfirm>
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Row justify="end" gutter={[0, 12]}>
        <Button onClick={() => setPublicLiabilityUploadState(true)} icon={<UploadOutlined />}>
          Upload Public Liability
        </Button>
      </Row>
      <Table
        loading={false}
        columns={columns}
        dataSource={isValidArray(publicLiabilityData) ? publicLiabilityData : []}
        rowKey="id"
        onChange={(pagination, filters, sorter, extra) => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      />
      <Modal title="Upload" centered visible={visible} footer={null} onCancel={() => setVisible(false)} width={500}>
        <Form onFinish={postUploadPdfFunction} layout="vertical" form={form}>
          <Row gutter={24} className="justify-content-center">
            <Col md={24}>
              <Form.Item
                name="expiry_date"
                label="Expiry Date:"
                initialValue={moment(moment())}
                rules={[
                  {
                    required: true,
                    message: "Please enter the expiry date.",
                  },
                ]}
              >
                <DatePicker format={dateFormat} onChange={onChange} onOk={onOk} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} className="justify-content-center">
            <Col md={24}>
              <Form.Item extra={uploadHint(UPLOAD_RULES.PDF)} name="file" label="File:">
                <Upload {...uploadSettings}>
                  <Button onClick={() => setVisible(true)}>
                    <UploadOutlined />
                    Click to Upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} className="justify-content-center">
            <Col md={24} style={{ textAlign: "center" }}>
              <Button htmlType="submit">Submit</Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal title="Upload Public Liability" centered visible={publicLiabilityUploadState} onCancel={() => setPublicLiabilityUploadState(false)} onOk={handlePublicLiabilityUpload} width={500} confirmLoading={uploadLoader}>
        <Form layout="vertical" form={publicLiabilityForm}>
          <Row gutter={[12, 0]}>
            <Col span={12}>
              <Form.Item
                label="Expiry Date"
                name="expiry_date"
                initialValue={moment(moment())}
                rules={[
                  {
                    required: true,
                    message: "Please enter the expiry date.",
                  },
                ]}
              >
                <DatePicker format={dateFormat} onChange={onChange} className="w-100" />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            extra={uploadHint(UPLOAD_RULES.PDF)}
            label="Select File"
            name="publicLiabilityFile"
            rules={[
              {
                required: true,
                message: "Please select the file.",
              },
            ]}
          >
            <Upload
              showUploadList={true}
              fileList={fileList}
              {...uploadProps(UPLOAD_RULES.PDF, { autoUpload: true })}
              customRequest={({ file, onSuccess }) => {
                setTimeout(() => {
                  onSuccess("Ok");
                });
              }}
              onChange={handleChange}
            >
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default memo(PublicLiability);
